import styled, { css } from 'styled-components'
import { StyledDomElement } from '../../App'
import { Box } from '../UI/Box'
import {
  h1Rules,
  h2Rules,
  h3Rules,
  h4Rules,
  h5Rules,
  h6Rules,
  pRules,
  spanRules,
  aRules,
  strongRules,
} from '../Library/Typeography'
import { pageWrapCssRules } from '../Header/styles'

type PageElementProps = { pageBackground?: string } & StyledDomElement

export const PageElement = styled.div<PageElementProps>`
  overflow: hidden;
  position: relative;
  # flex-direction: column;
  # align-items: center;
  # display: flex;
  min-height: 100vh;
  background: ${({ theme }) => theme.semantics.zap.surface.primary};
  background-color: ${(props) => props.theme.semantics.zap.surface.primary};
  .header-gradient {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 600px;
    z-index: -1;
    background: linear-gradient(
      180deg,
      rgba(4, 17, 27, 1) 0%,
      rgba(4, 17, 27, 0.1) 100%
    );
    z-index: 3;
  }
  .dashboard-header-gradient {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 500px;
    z-index: -1;
    background: linear-gradient(
      180deg,
      rgba(4, 17, 27, 1) 0%,
      rgba(4, 17, 27, 0.2) 50%,
      rgba(4, 17, 27, 1) 100%
    );
    z-index: 3;
  }
  h1:not([class^='sc-']):not([class*=' sc-']) {
    ${h1Rules}
  }

  h2:not([class^='sc-']):not([class*=' sc-']) {
    ${h2Rules}
  }

  h3:not([class^='sc-']):not([class*=' sc-']) {
    ${h3Rules}
  }

  h4:not([class^='sc-']):not([class*=' sc-']) {
    ${h4Rules}
  }

  h5:not([class^='sc-']):not([class*=' sc-']) {
    ${h5Rules}
  }

  h6:not([class^='sc-']):not([class*=' sc-']) {
    ${h6Rules}
  }

  p:not([class^='sc-']):not([class*=' sc-']) {
    ${pRules}
  }

  span:not([class^='sc-']):not([class*=' sc-']) {
    ${spanRules}
  }
  bbro
    am
    I
    losing
    my
    mind
    9:29
    was
    the
    page
    max
    width
    always
    1100px?
    9:29
    it
    was
    never
    like
    1400ish
    at
    any
    point?
    9:30
    I’m
    sure
    I
    saw
    somewhere
    1400px
    and
    even
    explicitly
    coded
    it
    and
    I
    don’t
    think
    like
    I’d
    make
    such
    a
    brash
    decision
    otherwisero
    am
    I
    losing
    my
    mind
    9:29
    was
    the
    page
    max
    width
    always
    1100px?
    9:29
    it
    was
    never
    like
    1400ish
    at
    any
    point?
    9:30
    I’m
    sure
    I
    saw
    somewhere
    1400px
    and
    even
    explicitly
    coded
    it
    and
    I
    don’t
    think
    like
    I’d
    make
    such
    a
    brash
    decision
    otherwise
    a:not([class^='sc-']):not([class*=' sc-']) {
    ${aRules}
  }

  strong:not([class^='sc-']):not([class*=' sc-']) {
    ${strongRules}
  }
`

type MaxWithProps = {
  width?: string
  maxWidth?: number
  posRelative?: boolean
} & StyledDomElement
export const MaxWidth = styled.div<MaxWithProps>`
  max-width: ${({ maxWidth }) => maxWidth}px;
  width: ${({ width }) => width};
  margin: auto;
  ${pageWrapCssRules}
  ${({ posRelative }) =>
    posRelative &&
    css`
      position: relative;
    `} //transition: max-width 0.3s ease-in-out;
`

export const Burger = styled(Box) <{ hideBurger: boolean; isOpen: boolean }>`
  align-items: center;
  z-index: ${({ hideBurger }) => (hideBurger ? -1 : 41)};
  opacity: ${({ hideBurger }) => (hideBurger ? 0 : 11)};
  position: absolute;
  top: 24px;
  width: auto;
  right: 12px;
  transition: 0.6s ease-in-out;
  ${({ theme, isOpen }) =>
    !theme.isDark &&
    isOpen &&
    css`
      filter: invert(1);
    `}
  @media screen and (min-width: 1000px) {
    display: none;
  }
`

export const Icon = styled.img<{ smallMargin?: boolean }>`
  margin-right: ${({ smallMargin }) => (smallMargin ? 8 : 16)}px;
  width: 24px;
  height: 24px;
`

export const WarningText = styled.span`
  font-size: 16px;
  line-height: 20px;
`

export const TextAndIcon = styled(Box)`
  @media screen and (max-width: 600px) {
    justify-content: center;
    align-items: center;
  }
`
